module.exports = "/_next/static/images/alerts-mobile@2x-0e31c1d3bf838372acb70332fcfad81f.png";